import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminChargeServices } from "./admin-charge.services";
import { ADMIN_CHARGE_KEYS } from "./admin-charge.keys";

export const useCreateAdminCharge = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: adminChargeServices.createAdminCharge,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ADMIN_CHARGE_KEYS.GET_ADMIN_CHARGES({}),
      });
    },
  });
};

export const useUpdateAdminCharge = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: adminChargeServices.updateAdminCharge,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ADMIN_CHARGE_KEYS.GET_ADMIN_CHARGES({}),
      });
    },
  });
};

export const useDeleteAdminCharge = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: adminChargeServices.deleteAdminCharge,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ADMIN_CHARGE_KEYS.GET_ADMIN_CHARGES({}),
      });
    },
  });
};
